@if (details().length) {
  <div class="ud-bloc">
    @if (intro()) {
      <span class="caption on-background-alt">{{ intro() }}</span>
    }

    <vl-expand-button
      size="small"
      [label]="'custom_enum.usage_detail' | trans"
      [(expanded)]="deplie"
    />

    @if (deplie()) {
      <div class="ud-liste" data-testid="dialog-confirm-details">
        @for (d of details(); track d.label) {
          <!--
            ⚠️ **Le nombre est DEVANT le libellé.** Aligné à droite, l'œil devait traverser toute la
            largeur pour relier « tarifs » à « 3 ». Devant, ça se lit d'un trait, et les libellés sont au
            pluriel neutre donc la lecture reste juste à 1 comme à 946.
          -->
          <div class="ud-ligne">
            <span class="ud-ligne__nb subheading-2 on-background">{{ d.count }}</span>
            <span class="ud-ligne__label body-2 on-background">{{ d.label }}</span>
          </div>

          <!--
            ⚠️ **Une source sans requête nommée n'affiche rien ici**, mais garde sa ligne de compte : la
            faire disparaître rendrait le total plus grand que la somme visible, sans explication.
          -->
          @if (d.elements?.length) {
            <ul class="ud-elements">
              @for (e of d.elements; track e.libelle) {
                <li>
                  @if (e.route) {
                    <a class="caption ud-lien" (click)="ouvrir(e.route)">{{ e.libelle }}</a>
                  } @else {
                    <span class="caption on-background-alt">{{ e.libelle }}</span>
                  }
                </li>
              }
              @if (d.tronque) {
                <!-- Le reste est annoncé, jamais masqué : 25 lignes sur 946 sans le dire serait faux. -->
                <li class="caption on-background-alt">{{ 'custom_enum.usage_reste' | trans }}</li>
              }
            </ul>
          }
        }
      </div>
    }
  </div>
}
